import { Pipe, PipeTransform } from '@angular/core';
import {Project} from '../../model/project';
import {Terminal} from '../../model/terminal';
import {Questionnaire} from '../../model/questionnaire';


@Pipe({
  name: 'type',
  pure: false // impure pipe, update value when we change language
})

export class TypePipe implements PipeTransform {

  constructor() { }

  transform(value:(Project|Terminal|Questionnaire)[],term: string,key:string): any[] {

    if(value == null) {
      return;
    }
    return value.filter(item => {
      return Object.keys(item).some(() => {
        switch (term.toLowerCase()) {
          case 'project': if(item instanceof Project) {return true;}break;
          case 'questionnaire':if(item instanceof Questionnaire) {return true;}break;
          case 'android': if(item instanceof Terminal) {return String(item[key]).toLowerCase().includes(term.toLowerCase());} break;
          case 'windows': if(item instanceof Terminal) {return String(item[key]).toLowerCase().includes(term.toLowerCase());} break;
          default:return true;
        }
      });
    });
  }
}
